'use client'
import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useRouter } from 'next/navigation'
import { Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

const TrendingProducts = (props: any) => {
  const router = useRouter()
  const Products = props?.data?.content[0]?.products
  const Navigate = (link: string) => {
    router.push(link)
  }
  return (
    <>
      <section className="section trending-product-section">
        <div className="container-fluid">
          {/* Title */}

          <div className="row align-items-center">
            {/* LEFT RATING COLUMN */}
            <div className="col-lg-4 col-xl-3 trending-product-content content-box text-start mb-3 mb-lg-0">
              <div className="content-sub-title">Curated</div>
              <h2 className="content-title-heading">Our Most Loved Designs</h2>
              <p>
                A curated selection of our most popular engagement ring designs, chosen for their
                beauty, craftmanship and lasting appeal.
              </p>
              <div className="category-product-btn">
                <Link
                  href="/engagement-rings/all-settings"
                  className="btn btn-custom custom-hover me-2 d-inline-flex align-items-center justify-content-center"
                >
                  View collection
                </Link>
              </div>
            </div>

            {/* RIGHT SWIPER */}
            <div className="col-lg-8 col-xl-9 px-md-3">
              <Swiper
                className="trending-product-swiper"
                modules={[Navigation, Autoplay]}
                navigation
                loop
                spaceBetween={12}
                slidesPerView={4}
                breakpoints={{
                  300: { slidesPerView: 1 },
                  640: { slidesPerView: 2 },
                  992: { slidesPerView: 2 },
                  1200: { slidesPerView: 3 },
                  1300: { slidesPerView: 4 }
                }}
              >
                {Products?.map((product: any, index: number) => (
                  <SwiperSlide>
                    <div className="trending-product-listing product-listing-box pointer">
                      <span
                        onClick={(e) =>
                          Navigate(
                            product.category_slug
                              .split(',')
                              .filter((slug: any) => (slug.match(/\//g) || []).length === 2)[0] +
                              '/' +
                              product.name.toLowerCase().replaceAll(' ', '-') +
                              '-sku-' +
                              product.sku
                          )
                        }
                        className="col-6 col-lg-3 best-seller-product-repeat"
                        key={index}
                      >
                        <div className="product-listing-img">
                          <Image
                            src={product.base_image}
                            className="w-100 h-100"
                            alt="Engagement Rings"
                            width={300}
                            height={300}
                            quality={85}
                            sizes="(max-width: 600px) 100vw, 300px"
                            style={{ objectFit: 'cover' }}
                          />
                        </div>

                        <div className="product-listing-detail">
                          <div className="product-listing-detail-title">
                            <span>{product.name}</span>
                          </div>
                          <div className="product-listing-detail-price">
                            <span>{product.formated_price}</span>
                          </div>
                        </div>
                      </span>
                    </div>
                  </SwiperSlide>
                ))}
                {Products?.map((product: any, index: number) => (
                  <SwiperSlide>
                    <div className="trending-product-listing product-listing-box pointer">
                      <span
                        onClick={(e) =>
                          Navigate(
                            product.category_slug
                              .split(',')
                              .filter((slug: any) => (slug.match(/\//g) || []).length === 2)[0] +
                              '/' +
                              product.name.toLowerCase().replaceAll(' ', '-') +
                              '-sku-' +
                              product.sku
                          )
                        }
                        className="col-6 col-lg-3 best-seller-product-repeat"
                        key={index}
                      >
                        <div className="product-listing-img">
                          <Image
                            src={product.base_image}
                            className="w-100 h-100"
                            alt="Engagement Rings"
                            width={300}
                            height={300}
                            quality={85}
                            sizes="(max-width: 600px) 100vw, 300px"
                            style={{ objectFit: 'cover' }}
                          />
                        </div>

                        <div className="product-listing-detail">
                          <div className="product-listing-detail-title">
                            <span>{product.name}</span>
                          </div>
                          <div className="product-listing-detail-price">
                            <span>{product.formated_price}</span>
                          </div>
                        </div>
                      </span>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default TrendingProducts
